"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Object_1 = require("./Object");
const Number_1 = require("./Number");
/**
 * Converte un array in un array di interi.
 *
 * @example
 * ```javascript
 *
 * const elements = [1, '2', '3.23', 4.2332, 'a']
 * const results = utility.array.intersect(elements)
 * console.log(results) // [1, 2, 3, 4, NaN]
 * ```
 *
 * @param {Array<any>} elements
 * @returns {Array<number>}
 */
exports.toInt = (elements) => elements.map(e => parseInt(e));
/**
 * Converte un array in un array di float.
 *
 * @example
 * ```javascript
 *
 * const elements = [1, '2', '3.23', 4.2332, 'a']
 * const results = utility.array.intersect(elements)
 * console.log(results) // [ 1, 2, 3.23, 4.2332, NaN ]
 * ```
 *
 * @param {Array<any>} elements
 * @returns {Array<number>}
 */
exports.toFloat = (elements) => elements.map(e => parseFloat(e));
/**
 * Controlla se il valore di una proprietà esiste all'interno di un array di oggetti.
 *
 * @example
 * ```javascript
 *
 * const elements = [{ 'id': 1 } { 'id': 2 }]
 * const result = utility.array.hasObjectProperty(elements, 'id', 2)
 * console.log(results) // true
 * ```
 *
 * @param {Array<object>} elements
 * @param {string} key
 * @param {(((value: any, item: any) => boolean) | any)} value
 * @returns {boolean}
 */
exports.hasObjectProperty = (elements, key, value) => exports.indexOfObjectProperty(elements, key, value) >= 0;
/**
 * Ritorna l'indice dell'oggetto che possiede la proprità cercata. Ritorna -1 se l'elemento non viene trovato
 *
 * @example
 * ```javascript
 *
 * // Esempio di una proprietà di primo livello
 * const elements = [
 *  { 'id': 1, 'token': 'xxx-yyy' }
 *  { 'id': 2, 'token': 'aaa-bbb' }
 * ]
 * const index = utility.array.indexOfObjectProperty(elements, 'token', 'aaa-bbb')
 * console.log(index) // 1
 * ```
 * @example
 * ```javascript
 *
 * // Esempio di una proprietà di primo secondo livello e funzione di validazione (3° parametro)
 * const elements = [
 *  { 'id': 1, 'data': { 'active': true, 'token': 'xxx-yyy' }}
 *  { 'id': 2, 'data': { 'active': true, 'token': 'aaa-bbb' }}
 * ]
 * const index = utility.array.indexOfObjectProperty(
 *  elements,
 *  'data.token',
 *  (value, item) => item.data.active && value === 'aaa-bbb'
 * )
 * console.log(index) // 1
 * ```
 *
 * @param {Array<object>} elements
 * @param {string} key
 * @param {(((value: any, item: any) => boolean) | any)} value
 * @returns {number}
 */
exports.indexOfObjectProperty = (elements, key, value) => {
    for (let i = elements.length - 1; i >= 0; i--)
        if (typeof value === 'function' ? value(Object_1.getProperty(elements[i], key, 'Nil'), elements[i]) : Object_1.getProperty(elements[i], key) === value)
            return i;
    return -1;
};
/**
 * Ritorna l'intersezione tra due array.
 *
 * @example
 * ```javascript
 *
 * const a = [1, 2, 3]
 * const b = [2, 3, 4]
 * console.log(utility.array.intersect(a, b)) // [ 2, 3 ]
 * ```
 *
 * @param {Array<any>} a
 * @param {Array<any>} b
 * @returns {Array<any>}
 */
exports.intersect = (a, b) => {
    var ai = 0, bi = 0;
    const result = new Array();
    while (ai < a.length && bi < b.length) {
        if (a[ai] < b[bi])
            ai++;
        else if (a[ai] > b[bi])
            bi++;
        else {
            result.push(a[ai]);
            ai++;
            bi++;
        }
    }
    return result;
};
/**
 * Ritorna il prossimo elemento di un array.
 *
 * @example
 * ```javascript
 *
 * const a = [1, 2, 3]
 * console.log(utility.array.next(a, 2)) // 1
 * ```
 *
 * @param {Array<any>} a
 * @param {number} index
 * @returns {Aany}
 */
exports.nextElement = (a, index) => a[Number_1.nextNumber(index, a.length)];
/**
 * Ritorna l'elemento precedente di un array.
 *
 * @example
 * ```javascript
 *
 * const a = [1, 2, 3]
 * console.log(utility.array.next(a, 2)) // 2
 * ```
 *
 * @param {Array<any>} a
 * @param {number} index
 * @returns {Aany}
 */
exports.prevElement = (a, index) => a[Number_1.prevNumber(index, a.length)];
/**
 * Ritorna un elemento random di un array.
 *
 * @example
 * ```javascript
 *
 * const a = [1, 2, 3]
 * console.log(utility.array.next(a, 2)) // 2
 * ```
 *
 * @param {Array<any>} a
 * @param {number} index
 * @returns {Aany}
 */
exports.randomElement = (a) => a[Number_1.randomInt(0, a.length - 1)];
//# sourceMappingURL=Array.js.map